import { render, staticRenderFns } from "./Hotspots.vue?vue&type=template&id=72e85246&"
import script from "./Hotspots.vue?vue&type=script&lang=js&"
export * from "./Hotspots.vue?vue&type=script&lang=js&"
import style0 from "./Hotspots.vue?vue&type=style&index=0&id=72e85246&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports